import { t } from '../../../common/i18n.js'
import { Language } from '../../../common/types/i18n.js'

const deviceTypes = t.urlShortener.deviceTypes

const isKnownDeviceType = (value: string): value is keyof typeof deviceTypes =>
    Object.prototype.hasOwnProperty.call(deviceTypes, value)

/**
 * Display label for `url_access_logs.device_type`. Null → "unknown"; a raw
 * value the i18n map does not know is shown as-is rather than hidden.
 */
export const deviceTypeLabel = (device: string | null, lang: Language): string => {
    if (device === null) return deviceTypes.unknown(lang)
    return isKnownDeviceType(device) ? deviceTypes[device](lang) : device
}
